import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { volunteerQuals } from "@/lib/quals";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

export function QualificationsDialog({ volunteer, onOpenChange, onSaved }) {
  const { settings } = useSettings();
  const [quals, setQuals] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (volunteer) setQuals(volunteerQuals(volunteer.qualifications));
  }, [volunteer]);

  const toggle = (q) => setQuals((p) => (p.includes(q) ? p.filter((x) => x !== q) : [...p, q]));

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/volunteers/${volunteer.id}/qualifications`, { qualifications: quals });
      toast.success("Qualifiche aggiornate");
      onSaved(data);
      onOpenChange(false);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!volunteer} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="quals-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Qualifiche · {volunteer?.name}</DialogTitle>
          <DialogDescription>Spunta per aggiungere, togli la spunta per revocare. Medico e Infermiere si gestiscono dall'elenco Medici e infermieri.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          {volunteerQuals(settings.qualifications).map((q) => (
            <label key={q} className="flex items-center gap-2 rounded-lg border border-border px-3 py-2 text-sm cursor-pointer hover:bg-muted">
              <Checkbox data-testid={`edit-qual-${q}`} checked={quals.includes(q)} onCheckedChange={() => toggle(q)} />
              <span>{q}</span>
            </label>
          ))}
        </div>
        <DialogFooter>
          <Button data-testid="save-quals" onClick={save} disabled={saving} className="rounded-full font-semibold">
            {saving ? "Salvataggio…" : "Salva qualifiche"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
